import React from 'react'
import i18n from 'i18next'
import * as R from 'ramda'

import Panel from '../../../UniformComponents/Panel'
import Button from '../../../UniformComponents/Button'
import Typography from '../../../UniformComponents/Typography'
import Select from '../../form/Select'
import AdminBox from './AdminBox'
import StatusBadge from './StatusBadge'
import RapidSurveyAccordion from './RapidSurveyAccordion'
import Anchor from '../../../UniformComponents/Anchor'

const SurveyOverview = ({
    store,
    openDownloadModal,
    openSurveyQuotaModal,
    changeLanguage,
}) => {
    const { survey } = store
    const { standardPages } = survey
    const isRapidSurvey = R.pathOr(false, ['metadata', 'isRapidSurvey'], survey)

    const getSubtextForStatus = () => {
        switch (store.surveyStatus) {
            case 'development':
                return 's_overview_development'
            case 'active':
                return 's_overview_active'
            case 'closed':
                return 's_overview_closed'
            default:
                return ''
        }
    }

    return (
        <Panel id="surveyOverview">
            <div className="heading-container">
                <div className="heading-title">
                    <h3>{i18n.t('s_overview')}</h3>

                    {process.env.SURVEY_STATE_REBRAND_2026 && (
                        <StatusBadge status={store.surveyStatus} />
                    )}
                </div>

                {process.env.SURVEY_STATE_REBRAND_2026 && (
                    <>
                        <Typography type="tiny" color="grey">{i18n.t(getSubtextForStatus())}</Typography>

                        {store.surveyStatus === 'development' && (
                            <Anchor href={`/survey/${survey.id}/distributeV2`}>
                                <Button
                                    cssClass="regular primary"
                                    label={i18n.t('s_overview_go_live')}
                                    onClick={() => null}
                                    style={{ width: '100%' }}
                                />
                            </Anchor>
                        )}

                        {store.surveyStatus === 'active' && (
                            <Anchor href={`/survey/${survey.id}/`}>
                                <Button
                                    cssClass="regular tertiary"
                                    label={i18n.t('s_overview_close')}
                                    onClick={() => null}
                                    style={{ width: '100%' }}
                                />
                            </Anchor>
                        )}
                    </>
                )}

                <div className="language-and-counter">
                    <p>{`Pages: ${standardPages.length}`}</p>
                    <p>{`${i18n.t('s_count_questions')}: ${survey.num_questions}`}</p>
                    <div className="builder-right-floating-panel-info-dropdown">
                        <Select
                            options={survey.metadata.locales.map((locale) => ({
                                value: locale,
                                label: '',
                                src: `${process.env.CDN_URL}/includes/images/flags/${locale}.png`,
                            }))}
                            defaultValue={store.surveyLocale}
                            onBlur={changeLanguage}
                        />
                    </div>
                </div>
            </div>

            <div className="button-container">
                <Button
                    cssClass="tertiary regular"
                    onClick={openDownloadModal}
                    label={i18n.t('s_export_options')}
                    icon="fal fa-folder-arrow-down"
                />
                {process.env.TRANSLATIONS && (
                    <Button
                        cssClass="tertiary regular"
                        onClick={() => { store.showTranslate = true }}
                        label={i18n.t('translation.title')}
                        icon="fal fa-print"
                    />
                )}

                {survey.metadata.allowQuotas && (
                    <Button
                        cssClass="tertiary regular"
                        icon="fal fa-plus"
                        label={i18n.t('s_add_overallsurveyquota')}
                        title="Add overall quota"
                        onClick={openSurveyQuotaModal}
                    />
                )}
            </div>

            {isRapidSurvey && <RapidSurveyAccordion store={store} />}

            <AdminBox store={store} survey={survey} />
        </Panel>
    )
}

export default SurveyOverview
